/**
 * Yasuo E Sweeping Blade — dash through a living enemy (FID-ABL-17).
 */
import { blinkToward, isWithinAbilityRange, scaleLolDistance } from '../combat/abilityArea.js';

export const YASUO_E_RANGE = 475;
export const YASUO_E_BEYOND = 50;

export function pickSweepingBladeTarget(caster, tx, ty, entities = []) {
  if (!caster) return null;
  let best = null;
  let bestD = Infinity;
  for (const e of entities) {
    if (!e || e.isDead || e.team === caster.team) continue;
    if (!isWithinAbilityRange(caster, e, YASUO_E_RANGE, caster)) continue;
    const d = Math.hypot(e.x - tx, e.y - ty);
    if (d < bestD) {
      best = e;
      bestD = d;
    }
  }
  return best;
}

function dashThroughTarget(caster, target) {
  const dx = target.x - caster.x;
  const dy = target.y - caster.y;
  const len = Math.hypot(dx, dy) || 1;
  const extra = scaleLolDistance(YASUO_E_BEYOND, caster);
  blinkToward(
    caster,
    target.x + (dx / len) * extra,
    target.y + (dy / len) * extra,
    YASUO_E_RANGE
  );
}

export function applySweepingBlade(caster, tx, ty, entities = []) {
  const target = pickSweepingBladeTarget(caster, tx, ty, entities);
  if (!target) return false;
  dashThroughTarget(caster, target);
  target.takeDamage(60 + (caster.ad || 0) * 0.6, caster, 'physical');
  return true;
}
